module.exports = __webpack_public_path__ + "img/Frame 5140.b952400a.jpg";